<!-- eslint-disable no-undef -->
<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div>
    <div class="date-buttons">
      <button
        :class="{ active: selectedButton === 'today' }"
        class="date-button"
        @click="selectButton('today')"
      >
        Hoje
      </button>
      <button
        :class="{ active: selectedButton === 'last7Days' }"
        class="date-button"
        @click="selectButton('last7Days')"
      >
        Últimos 7 dias
      </button>
      <button
        :class="{ active: selectedButton === 'last30Days' }"
        class="date-button"
        @click="selectButton('last30Days')"
      >
        Últimos 30 dias
      </button>
      <button
        :class="{ active: selectedButton === 'last6Months' }"
        class="date-button"
        @click="selectButton('last6Months')"
      >
        Últimos 6 meses
      </button>
      <date-picker
        v-model="filterRange"
        range
        placeholder="Intervalo de Datas"
        @change="initializeMap()"
      />
    </div>
    <div class="map-content">
      <div class="card-panel">
        <div class="card-panel-header">
          <i class="fa-solid fa-layer-group">&nbsp;</i>
          <strong>Camadas</strong>
        </div>
        <div style="font-weight: 400">
          Clique nos marcadores para visualizar os indicadores no mapa.
        </div>
        <h2>DADOS DE SEGURANÇA PÚBLICA</h2>
        <ul>
          <li :class="{ liCheckedT1: checkedT1 }">
            <label style="margin-bottom: 10px">
              <input v-model="checkedT1" type="checkbox" @change="heatmap()" /> Sensação de
              Segurança
            </label>
            <div v-if="checkedT1">
              <div class="progress">&nbsp;</div>
              <div class="subtitle">
                <span>Seguro</span>
                <span>Neutro</span>
                <span>Inseguro</span>
              </div>
            </div>
          </li>
          <li class="divider">MUNICIPAL</li>
          <li>
            <label style="margin-bottom: 10px">
              <input v-model="checkedT2" type="checkbox" @change="initializeMap" /> Efetivo da
              Guarda Municipal
            </label>
          </li>
          <li class="divider">ESTADUAL/FEDERAL</li>
          <li>
            <label style="margin-bottom: 10px">
              <input v-model="checkedT4" type="checkbox" @change="initializeMap" /> Unidades de
              Segurança
            </label>
          </li>
          <li>
            <label style="margin-bottom: 10px">
              <input v-model="checkedT3" type="checkbox" @change="initializeMap" /> Ocorrências
            </label>
            <ul v-if="checkedT3">
              <li v-for="type in types" :key="type">
                <label>
                  <div>
                    <input
                      v-model="typeOccur"
                      :name="type"
                      type="checkbox"
                      :value="type"
                      @change="initializeMap()"
                    />
                    {{ type }}
                  </div>
                  <div><span :class="getIconClass(type)">&nbsp;</span></div>
                </label>
              </li>
            </ul>
          </li>
          <li>
            <button class="btn-uncheck" @click="uncheckAll()">Desmarcar Todos</button>
          </li>
        </ul>
      </div>
      <div id="map">
        <div v-if="loading" class="loading">Carregando...</div>
        <div v-if="!checkedT1" class="buttons-ctrl">
          <button
            :class="{ active: selectedButton != 'today' }"
            class="map-button"
            @click="selectButton('last6Months')"
          >
            Passado
          </button>
          <button
            :class="{ active: selectedButton == 'today' }"
            class="map-button"
            @click="selectButton('today')"
          >
            Tempo Real
          </button>
          <button
            :class="{ active: selectedButton == 'previsao' }"
            class="map-button"
            @click="showAlert"
          >
            Previsão
          </button>
        </div>
        <div id="map-canva" :class="{ 'd-none': !checkedT1 }">
          <div id="mapes" ref="mapes" class="mapes">&nbsp;</div>
        </div>
        <div id="map-canva-google" :class="{ 'd-none': checkedT1 }">
          <div id="mapgoogle" ref="mapgoogle">&nbsp;</div>
        </div>
      </div>
    </div>

    <Accordion
      class="accordion"
      style="margin-top: 1rem"
      :multiple="true"
      v-if="$page.props.auth.user.email === 'super@smart-destination.com'"
    >
      <AccordionTab header="Configurar Insight" class="accordion-tab">
        <label for="insightTitle">Título do Insight</label>
        <input
          v-model="insight.title"
          :disabled="loadingInsight"
          type="text"
          placeholder="Digite o título do insight"
        />
        <label for="insightGpt">Fale com o GPT</label>
        <textarea
          v-model="insight.text"
          :disabled="loadingInsight"
          placeholder="Digite sua mensagem..."
          style="height: 100px; overflow-y: auto"
        >
&nbsp;</textarea
        >
        <div>
          <p><strong>[OCORRENCIAS]</strong> - Todas as categorias</p>
          <p><strong>[NUMERO_OCORRENCIAS]</strong> - Totalizador de ocorrências</p>
          <p><strong>[BAIRROS]</strong> - Bairros do Recentro</p>
          <p><strong>[SENSACAO_SEGURANCA]</strong> - Sensação de Segurança</p>
          <p>
            <strong>[QUANTIDADE_OPERACOES_GUARDA_MUNICIPAL]</strong> - Efetivo da Guarda Municipal
          </p>
          <p><strong>[PERCENTUAL_GENERO]</strong> - Percentual do gênero das vítimas</p>
          <p><strong>[FAIXA_ETARIA]</strong> - Faixa etária vítimas por bairros</p>
          <p><strong>[VITIMAS_REGIAO]</strong> - Relação das Vítimas por Regiãpo</p>
          <p><strong>[UNIDADE_SEGURANÇA]</strong> - Unidades de segurança</p>
        </div>
        <div class="button-group" style="margin-top: 20px">
          <button
            :class="{ disabled: loadingInsight }"
            class="btn btn-primary"
            @click="!loadingInsight && saveInsight()"
          >
            Salvar
          </button>
          <button
            :class="{ disabled: loadingInsight }"
            class="btn btn-dark"
            @click="
              showPrompt = false
              insight = {}
            "
          >
            Cancelar
          </button>
        </div>
      </AccordionTab>
    </Accordion>
    <Accordion v-if="superuser" class="accordion" style="margin-top: 1rem">
      <AccordionTab
        v-for="item in insights"
        :key="item.id"
        :header="item.title"
        class="accordion-tab"
      >
        <label for="insightTitle">Título do Insight</label>
        <input
          v-model="item.title"
          type="text"
          placeholder="Digite o título do insight"
          :disabled="loadingInsight"
        />
        <label for="insightGpt">Fale com o GPT</label>
        <textarea
          v-model="item.text"
          placeholder="Digite sua mensagem..."
          style="height: 100px; overflow-y: auto"
          :disabled="loadingInsight"
        >
&nbsp;</textarea
        >
        <div class="button-group" style="margin-top: 20px">
          <button
            :class="{ disabled: loadingInsight }"
            class="btn btn-primary"
            @click="!loadingInsight && saveUpdateInsight(item.id)"
          >
            Salvar
          </button>
          <button
            :class="{ disabled: loadingInsight }"
            class="btn btn-danger"
            @click="!loadingInsight && removeInsight(item.id)"
          >
            Excluir
          </button>
        </div>
      </AccordionTab>
    </Accordion>
  </div>
</template>
<script>
import Layout from './Layout.vue'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import moment from 'moment'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import 'leaflet.heat/dist/leaflet-heat.js'
import 'leaflet.heat/dist/leaflet-heat.js'
import 'leaflet-providers/leaflet-providers.js'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import { Loader } from '@googlemaps/js-api-loader'
import * as THREE from 'three'
export default {
  components: {
    DatePicker,
    Accordion,
    AccordionTab,
  },
  layout: Layout,
  props: {
    securitySearch: {
      type: Array,
      default: () => [],
    },
    occurrences: {
      type: Array,
      default: () => [],
    },
    types: {
      type: Array,
      default: () => [],
    },
    municipalGuard: {
      type: Array,
      default: () => [],
    },
    federalPoliceStation: {
      type: Array,
      default: () => [],
    },
    listinsights: {
      type: Array,
      default: () => [],
    },
    superuser: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tela: 'mapes',
      selectedButton: 'last6Months',
      selectedButton2: 'passado',
      loading: false,
      loadingInsight: false,
      showPrompt: false,
      insight: {},
      updateInsight: {},
      insights: this.listinsights,
      checkedT1: false,
      checkedT2: false,
      checkedT3: true,
      checkedT4: false,
      filterRange: [],
      interval: ['now', '7days', '30days', '6months'],
      layerMaps: [
        'https://api.maptiler.com/maps/dataviz/256/{z}/{x}/{y}@2x.png?key=GX4tcvbsx32DGx0ztZ3l',
        'https://api.maptiler.com/maps/bright-v2/256/{z}/{x}/{y}@2x.png?key=GX4tcvbsx32DGx0ztZ3l',
        'https://api.maptiler.com/maps/satellite/256/{z}/{x}/{y}@2x.jpg?key=GX4tcvbsx32DGx0ztZ3l',
      ],
      layerMap: 0,
      occurrencesToday: this.occurrences.filter(
        (item) => item.date == moment().format('YYYY-MM-DD'),
      ),
      occurrenceslast7Days: this.occurrences.filter(
        (item) =>
          moment(item.date).format('YYYY-MM-DD') >= moment().subtract(7, 'd').format('YYYY-MM-DD'),
      ),
      occurrenceslast30Days: this.occurrences.filter(
        (item) =>
          moment(item.date).format('YYYY-MM-DD') >= moment().subtract(30, 'd').format('YYYY-MM-DD'),
      ),
      occurrenceslast6Months: this.occurrences.filter(
        (item) =>
          moment(item.date).format('YYYY-MM-DD') >= moment().subtract(6, 'M').format('YYYY-MM-DD'),
      ),
      occurrencesRange: [],
      typeOccur: this.types,

      map: null,
      markers: [],
      osmb: null,
      animationFrameId: null,
    }
  },
  async mounted() {
    await this.initializeMap()
  },
  methods: {
    async initializeMap() {
      await this.loadScript('./OMSBuildings.js')

      const apiOptions = {
        apiKey: 'AIzaSyDEP0W1aRUiHh3K8izlwk7zUWj6-XyotxY',
        version: 'beta',
        libraries: ['marker', 'places'],
      }

      const apiLoader = new Loader(apiOptions)
      await apiLoader.load()

      const mapOptions = {
        center: { lat: -8.08, lng: -34.90191 },
        zoom: 16,
        tilt: 30,
        mapId: 'd3b3f166493c990b',
        mapTypeId: 'satellite',
        mapTypeControl: true,
        zoomControl: true,
        fullscreenControl: true,
      }

      this.map = new google.maps.Map(this.$refs.mapgoogle, mapOptions)

      await this.initWebGLOverlayView()

      this.filterMap()
    },
    async filterMap() {
      this.checkedT1 = false
      if (this.filterRange.length > 0) {
        let initialDate = moment(this.filterRange[0]).format('YYYY-MM-DD')
        let finalDate = moment(this.filterRange[1]).format('YYYY-MM-DD')
        this.loading = true
        await axios
          .get('/security/occurrences', {
            params: { initialDate: initialDate, finalDate: finalDate, type: this.typeOccur },
          })
          .then((response) => {
            this.selectedButton = 'range'
            this.occurrencesRange = response.data.occurrences
            this.loading = false
          })
      } else {
        this.occurrencesToday = this.occurrences.filter(
          (occ) => occ.date == moment().format('YYYY-MM-DD') && this.typeOccur.includes(occ.type),
        )
        this.occurrenceslast7Days = this.occurrences.filter(
          (occ) =>
            moment(occ.date).format('YYYY-MM-DD') >=
              moment().subtract(7, 'd').format('YYYY-MM-DD') && this.typeOccur.includes(occ.type),
        )
        this.occurrenceslast30Days = this.occurrences.filter(
          (occ) =>
            moment(occ.date).format('YYYY-MM-DD') >=
              moment().subtract(30, 'd').format('YYYY-MM-DD') && this.typeOccur.includes(occ.type),
        )
        this.occurrenceslast6Months = this.occurrences.filter(
          (occ) =>
            moment(occ.date).format('YYYY-MM-DD') >=
              moment().subtract(6, 'M').format('YYYY-MM-DD') && this.typeOccur.includes(occ.type),
        )
      }
      if (this.checkedT3) {
        if (this.selectedButton == 'today') {
          this.occurrencesToday.map((value) => {
            this.addMarker({
              lat: parseFloat(value.lat),
              lng: parseFloat(value.long),
              type: value.type,
            })
          })
        } else if (this.selectedButton == 'last7Days') {
          this.occurrenceslast7Days.map((value) => {
            this.addMarker({
              lat: parseFloat(value.lat),
              lng: parseFloat(value.long),
              type: value.type,
            })
          })
        } else if (this.selectedButton == 'last30Days') {
          this.occurrenceslast30Days.map((value) => {
            this.addMarker({
              lat: parseFloat(value.lat),
              lng: parseFloat(value.long),
              type: value.type,
            })
          })
        } else if (this.selectedButton == 'last6Months') {
          this.occurrenceslast6Months.map((value) => {
            this.addMarker({
              lat: parseFloat(value.lat),
              lng: parseFloat(value.long),
              type: value.type,
            })
          })
        } else if (this.selectedButton == 'range') {
          this.occurrencesRange.map((value) => {
            this.addMarker({
              lat: parseFloat(value.lat),
              lng: parseFloat(value.long),
              type: value.type,
            })
          })
        }
      }
      if (this.checkedT2) {
        this.municipalGuard.map((item) => {
          this.addMarker({
            lat: parseFloat(item.latitude),
            lng: parseFloat(item.longitude),
            type: 'Guarda Municipal',
          })
        })
      }
      if (this.checkedT4) {
        this.federalPoliceStation.map((item) => {
          this.addMarker({
            lat: parseFloat(item.latitude),
            lng: parseFloat(item.longitude),
            type: 'Unidades de Segurança',
          })
        })
      }
    },
    async initWebGLOverlayView() {
      let scene, renderer, camera
      const webGLOverlayView = new google.maps.WebGLOverlayView()

      webGLOverlayView.onAdd = () => {
        scene = new THREE.Scene()
        camera = new THREE.PerspectiveCamera()
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.75)
        scene.add(ambientLight)
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.25)
        directionalLight.position.set(0.5, -1, 0.5)
        scene.add(directionalLight)

        this.osmb = new window.OSMBuildings({ minZoom: 15, maxZoom: 20 })
        this.osmb.addGeoJSONTiles(
          'https://{s}-data.onegeo.co/maps/tiles/{z}/{x}/{y}.json?token=746m9n5tkutfxkjj',
          { fixedZoom: 15 },
        )
        scene.add(this.osmb)
      }

      // eslint-disable-next-line no-unused-vars
      webGLOverlayView.onContextRestored = ({ gl }) => {
        renderer = new THREE.WebGLRenderer({
          canvas: gl.canvas,
          context: gl,
          ...gl.getContextAttributes(),
        })

        renderer.autoClear = false

        const animate = () => {
          this.animationFrameId = requestAnimationFrame(animate)
          this.map.moveCamera({
            tilt: 30,
            heading: this.map.getHeading() + 0.2,
            zoom: this.map.getZoom(),
          })
          renderer.render(scene, camera)
        }
        animate()
      }

      // eslint-disable-next-line no-unused-vars
      webGLOverlayView.onDraw = ({ gl, transformer }) => {
        webGLOverlayView.requestRedraw()
        try {
          renderer.render(scene, camera)
          renderer.resetState()
        } catch (error) {
          if (error.message.includes('ResizeObserver loop')) {
            console.warn('ResizeObserver loop error ignored.')
          } else {
            throw error
          }
        }
      }

      this.map.addListener('mousedown', () => cancelAnimationFrame(this.animationFrameId))
      this.map.addListener('touchstart', () => cancelAnimationFrame(this.animationFrameId))

      webGLOverlayView.setMap(this.map)
    },
    addMarker({ lat, lng, type }) {
      const marker = new google.maps.Marker({
        position: { lat, lng },
        map: this.map,
        icon: {
          url: this.getIconSVG(type),
          scale: 16,
          //path: path || google.maps.SymbolPath.CIRCLE,
          //fillColor: color,
          //fillOpacity: 1,
          //strokeColor: '#ffffff',
          //strokeWeight: 2,
          //scale: 10,
        },
      })

      this.markers.push(marker)
    },
    addMarkerPath({ lat, lng, icon }) {
      const marker = new google.maps.Marker({
        position: { lat, lng },
        map: this.map,
        icon: icon,
      })

      this.markers.push(marker)
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = src
        script.onload = () => resolve()
        script.onerror = () => reject(new Error(`Script load error for ${src}`))
        document.head.appendChild(script)
      })
    },
    getIconClass(type) {
      switch (type) {
        case 'Homicidio/Tentativa':
          return 'icon-marker-1'
        case 'Tentativa/Roubo':
          return 'icon-marker-2'
        case 'Briga':
          return 'icon-marker-3'
        case 'Ação policial':
          return 'icon-marker-4'
        case 'Ataque a civis':
          return 'icon-marker-5'
        case 'Não identificado':
          return 'icon-marker-6'
        case 'Operação policial':
          return 'icon-marker-7'
        case 'Sequestro/Cárcere Privado':
          return 'icon-marker-8'
      }
    },
    async heatmap() {
      if (this.checkedT1) {
        document.getElementById('map-canva').innerHTML =
          "<div id='mapes' ref='mapes' class='mapes'>&nbsp;</div>"
        this.checkedT3 = false
        this.checkedT2 = false
        this.checkedT4 = false

        if (this.filterRange.length > 0) {
          let initialDate = moment(this.filterRange[0]).format('YYYY-MM-DD')
          let finalDate = moment(this.filterRange[1]).format('YYYY-MM-DD')
          this.loading = true
          await axios
            .get('/security/occurrences', {
              params: { initialDate: initialDate, finalDate: finalDate, type: this.typeOccur },
            })
            .then((response) => {
              this.selectedButton = 'range'
              this.occurrencesRange = response.data.securitySearch
              this.loading = false
            })
        } else {
          let initialDate = moment().format('YYYY-MM-DD')
          let finalDate = moment().format('YYYY-MM-DD')
          this.loading = true
          await axios
            .get('/security/occurrences', {
              params: { initialDate: initialDate, finalDate: finalDate, type: this.typeOccur },
            })
            .then((response) => {
              this.loading = false
            })
          this.occurrencesToday = this.securitySearch.filter(
            (occ) =>
              occ.date_search == moment().format('YYYY-MM-DD') &&
              occ.search >= 0 &&
              occ.search <= 6,
          )
          this.occurrenceslast7Days = this.securitySearch.filter(
            (occ) =>
              moment(occ.date_search).format('YYYY-MM-DD') >=
                moment().subtract(7, 'd').format('YYYY-MM-DD') &&
              occ.search >= 0 &&
              occ.search <= 6,
          )
          this.occurrenceslast30Days = this.securitySearch.filter(
            (occ) =>
              moment(occ.date_search).format('YYYY-MM-DD') >=
                moment().subtract(30, 'd').format('YYYY-MM-DD') &&
              occ.search >= 0 &&
              occ.search <= 6,
          )
          this.occurrenceslast6Months = this.securitySearch.filter(
            (occ) =>
              moment(occ.date_search).format('YYYY-MM-DD') >=
                moment().subtract(6, 'M').format('YYYY-MM-DD') &&
              occ.search >= 0 &&
              occ.search <= 6,
          )
        }

        let map = L.map('mapes').setView([-8.113, -34.877], 13.2) // Ajuste o nível de zoom conforme necessário
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(map)
        let addressPoints = []
        if (this.selectedButton == 'today') {
          addressPoints = this.occurrencesToday.map((value) => {
            return [value.latitude, value.longitude]
          })
        } else if (this.selectedButton == 'last7Days') {
          addressPoints = this.occurrenceslast7Days.map((value) => {
            return [value.latitude, value.longitude]
          })
        } else if (this.selectedButton == 'last30Days') {
          addressPoints = this.occurrenceslast30Days.map((value) => {
            return [value.latitude, value.longitude]
          })
        } else if (this.selectedButton == 'last6Months') {
          addressPoints = this.occurrenceslast6Months.map((value) => {
            return [value.latitude, value.longitude]
          })
        } else if (this.selectedButton == 'range') {
          addressPoints = this.occurrencesRange.map((value) => {
            return [value.latitude, value.longitude]
          })
        }
        L.heatLayer(addressPoints).addTo(map)
      } else {
        await this.initializeMap()
      }
    },
    async saveInsight() {
      this.loadingInsight = true
      const data = {
        title: this.insight.title,
        text: this.insight.text,
      }
      try {
        const response = await axios.post('/security-insights', data)
        const newInsight = response.data
        this.insights.push(newInsight)
        this.insight = {}
        this.showPrompt = false
      } catch (error) {
        console.error('Error saving insight:', error)
      } finally {
        this.loadingInsight = false
      }
    },

    async saveUpdateInsight(id) {
      this.loadingInsight = true
      try {
        const data = this.insights.filter((item) => item.id == id)
        await axios
          .put(`/security-insights/${id}`, data[0])
          .then((resp) => {
            this.insights = resp.data
          })
          .finally(() => {
            this.loadingInsight = false
          })
      } catch (error) {
        console.error('Error saving insight:', error)
        this.loadingInsight = false
      }
    },
    async removeInsight(id) {
      if (confirm('Tem certeza que deseja excluir o prompt?') == true) {
        this.loadingInsight = true
        try {
          await axios
            .delete(`/security-insights/${id}`)
            .then(() => {
              this.insights = this.insights.filter((insight) => insight.id != id)
            })
            .finally(() => {
              this.loadingInsight = false
            })
        } catch (error) {
          console.error('Error delleting insight:', error)
          this.loadingInsight = false
        }
      }
    },
    changeLayerMap(key) {
      this.layerMap = key
      this.initializeMap()
    },
    uncheckAll() {
      this.checkedT3 = false
      this.initializeMap()
    },
    selectButton(button) {
      this.selectedButton = button
      this.filterRange = []
      if (this.checkedT3) {
        this.initializeMap()
      } else {
        this.heatmap()
      }
    },
    showAlert() {
      alert('Em desenvolvimento')
    },
    getIconSVG(type) {
      switch (type) {
        case 'Homicidio/Tentativa':
          return (
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(`
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 50 50" width="20" height="20">
              <defs>
                <style>
                  .cls-1 { fill: rgb(209, 53, 43); stroke-width: 0px; }
                  .cls-2 { opacity: .4; }
                </style>
              </defs>
              <g class="cls-2">
                <circle class="cls-1" cx="25" cy="25" r="23"/>
              </g>
              <circle class="cls-1" cx="24.71" cy="25.05" r="14.29"/>
            </svg>
          `)
          )
        case 'Tentativa/Roubo':
          return (
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(`
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 50 50" width="20" height="20">
              <defs>
                <style>
                  .cls-1 { fill: #52aba4; stroke-width: 0px; }
                  .cls-2 { opacity: .4; }
                </style>
              </defs>
              <g class="cls-2">
                <circle class="cls-1" cx="25" cy="25" r="23"/>
              </g>
              <circle class="cls-1" cx="24.71" cy="25.05" r="14.29"/>
            </svg>
          `)
          )
        case 'Briga':
          return (
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(`
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 50 50" width="20" height="20">
              <defs>
                <style>
                  .cls-1 { fill: #b98859; stroke-width: 0px; }
                  .cls-2 { opacity: .4; }
                </style>
              </defs>
              <g class="cls-2">
                <circle class="cls-1" cx="25" cy="25" r="23"/>
              </g>
              <circle class="cls-1" cx="24.71" cy="25.05" r="14.29"/>
            </svg>
          `)
          )
        case 'Ação policial':
          return (
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(`
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 50 50" width="20" height="20">
              <defs>
                <style>
                  .cls-1 { fill: rgb(23, 52, 207); stroke-width: 0px; }
                  .cls-2 { opacity: .4; }
                </style>
              </defs>
              <g class="cls-2">
                <circle class="cls-1" cx="25" cy="25" r="23"/>
              </g>
              <circle class="cls-1" cx="24.71" cy="25.05" r="14.29"/>
            </svg>
          `)
          )
        case 'Ataque a civis':
          return (
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(`
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 50 50" width="20" height="20">
              <defs>
                <style>
                  .cls-1 { fill: rgb(231, 183, 8); stroke-width: 0px; }
                  .cls-2 { opacity: .4; }
                </style>
              </defs>
              <g class="cls-2">
                <circle class="cls-1" cx="25" cy="25" r="23"/>
              </g>
              <circle class="cls-1" cx="24.71" cy="25.05" r="14.29"/>
            </svg>
          `)
          )
        case 'Não identificado':
          return (
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(`
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 50 50" width="20" height="20">
              <defs>
                <style>
                  .cls-1 { fill: rgb(117, 117, 117); stroke-width: 0px; }
                  .cls-2 { opacity: .4; }
                </style>
              </defs>
              <g class="cls-2">
                <circle class="cls-1" cx="25" cy="25" r="23"/>
              </g>
              <circle class="cls-1" cx="24.71" cy="25.05" r="14.29"/>
            </svg>
          `)
          )
        case 'Operação policial':
          return (
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(`
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 50 50" width="20" height="20">
              <defs>
                <style>
                  .cls-1 { fill: rgb(232, 14, 203); stroke-width: 0px; }
                  .cls-2 { opacity: .4; }
                </style>
              </defs>
              <g class="cls-2">
                <circle class="cls-1" cx="25" cy="25" r="23"/>
              </g>
              <circle class="cls-1" cx="24.71" cy="25.05" r="14.29"/>
            </svg>
          `)
          )
        case 'Sequestro/Cárcere Privado':
          return (
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(`
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 50 50" width="20" height="20">
              <defs>
                <style>
                  .cls-1 { fill: blueviolet; stroke-width: 0px; }
                  .cls-2 { opacity: .4; }
                </style>
              </defs>
              <g class="cls-2">
                <circle class="cls-1" cx="25" cy="25" r="23"/>
              </g>
              <circle class="cls-1" cx="24.71" cy="25.05" r="14.29"/>
            </svg>
          `)
          )
        case 'Unidades de Segurança':
          return (
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(`
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 640"  width="30" height="30">
              <defs>
                <style>
                  .cls-1 {
                    fill: #2FDBE1;
                    stroke-width: 0px;
                  }
                </style>
              </defs>
              <path class="cls-1" d="M256,0C139.2,0,44.5,94.7,44.5,211.5s211.5,300.5,211.5,300.5c0,0,211.5-139.8,211.5-300.5C467.5,94.7,372.8,0,256,0ZM256,375.9c-90.8,0-164.4-73.6-164.4-164.4S165.2,47.1,256,47.1s164.4,73.6,164.4,164.4-73.6,164.4-164.4,164.4Z"/>
              <path class="cls-1" d="M329.8,165.3l7-7.3-40.2-34s0,0-.1.1c-.1-.1-.2-.2-.4-.3-.1.1-.3.3-.4.4h.7c-4,4.2-9.7,15.5-19.8,15.5s-16.7-11.3-21.3-15.3h0c0-.1,0,0,0,0,0,0,0,0,0,0h0c-4.6,4.1-11.3,15.4-21.3,15.4s-15.6-11-19.6-15.4h.6c-.1-.1-.3-.3-.4-.4-.1,0-.2.2-.3.3,0,0-.1-.1-.2-.2l-40.2,34,7,7.3c8.2,8.6,17.9,18.2,10,39.4-6.9,18.9-18.1,29.8-18.1,44.7,0,26.7,17.1,46.4,46.9,53.9,21.4,5.5,24.7,7.8,35.6,16.7,0,0,0,0,0,0,0,0,0,0,0,0,11-8.9,14.2-11.2,35.6-16.7,29.8-7.6,46.9-27.2,46.9-53.9s-11.2-25.8-18.1-44.7c-7.8-21.3,1.8-30.8,10-39.5ZM273.9,250.8l-18.6-9.9-18.6,9.9,3.5-20.9-15-14.8,20.8-3.1,9.3-19,9.3,19,20.8,3.1-15,14.8,3.5,20.9Z"/>
            </svg>
          `)
          )
        case 'Guarda Municipal':
          return (
            'data:image/svg+xml;charset=UTF-8,' +
            encodeURIComponent(`
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 640"  width="30" height="30">
              <defs>
                <style>
                  .cls-1 {
                    fill: #BFD641;
                    stroke-width: 0px;
                  }
                </style>
              </defs>
              <path class="cls-1" d="M256,0C139.2,0,44.5,94.7,44.5,211.5s211.5,300.5,211.5,300.5c0,0,211.5-139.8,211.5-300.5C467.5,94.7,372.8,0,256,0ZM256,375.9c-90.8,0-164.4-73.6-164.4-164.4S165.2,47.1,256,47.1s164.4,73.6,164.4,164.4-73.6,164.4-164.4,164.4Z"/>
              <path class="cls-1" d="M329.8,165.3l7-7.3-40.2-34s0,0-.1.1c-.1-.1-.2-.2-.4-.3-.1.1-.3.3-.4.4h.7c-4,4.2-9.7,15.5-19.8,15.5s-16.7-11.3-21.3-15.3h0c0-.1,0,0,0,0,0,0,0,0,0,0h0c-4.6,4.1-11.3,15.4-21.3,15.4s-15.6-11-19.6-15.4h.6c-.1-.1-.3-.3-.4-.4-.1,0-.2.2-.3.3,0,0-.1-.1-.2-.2l-40.2,34,7,7.3c8.2,8.6,17.9,18.2,10,39.4-6.9,18.9-18.1,29.8-18.1,44.7,0,26.7,17.1,46.4,46.9,53.9,21.4,5.5,24.7,7.8,35.6,16.7,0,0,0,0,0,0,0,0,0,0,0,0,11-8.9,14.2-11.2,35.6-16.7,29.8-7.6,46.9-27.2,46.9-53.9s-11.2-25.8-18.1-44.7c-7.8-21.3,1.8-30.8,10-39.5ZM273.9,250.8l-18.6-9.9-18.6,9.9,3.5-20.9-15-14.8,20.8-3.1,9.3-19,9.3,19,20.8,3.1-15,14.8,3.5,20.9Z"/>
            </svg>
          `)
          )
      }
    },
  },
}
</script>

<style>
.button-group {
  display: flex;
  gap: 1rem;
}
.btn {
  background-color: #ccc;
  padding: 0.5rem 1rem;
  border-radius: 5px;
}
.btn.btn-primary {
  background-color: #43b3ae;
  color: #fff;
  font-weight: bold;
}
.btn.btn-primary.disabled,
.btn.btn-primary.disabled:hover {
  background-color: #9cdbd7;
  color: #fff;
  font-weight: bold;
  cursor: not-allowed;
}
.btn.btn-primary:hover {
  background-color: #3b9d98;
}
.btn.btn-default {
  background-color: #eee;
  font-weight: bold;
}
.btn.btn-default:hover {
  background-color: #ddd;
}
.btn.btn-dark {
  background-color: #333;
  color: #fff;
  font-weight: bold;
}
.btn.btn-dark.disabled,
.btn.btn-dark.disabled:hover {
  background-color: #7c7c7c;
  color: #fff;
  font-weight: bold;
  cursor: not-allowed;
}
.btn.btn-dark:hover {
  background-color: #000;
}
.btn.btn-danger {
  background-color: #df4545;
  color: #fff;
  font-weight: bold;
}
.btn.btn-danger.disabled,
.btn.btn-danger.disabled:hover {
  background-color: #efa8a8;
  color: #fff;
  font-weight: bold;
  cursor: not-allowed;
}
.btn.btn-danger:hover {
  background-color: #b23636;
}
.accordion .accordion-tab label {
  display: block;
  margin-bottom: 0.5rem;
}
.accordion .accordion-tab input,
.accordion .accordion-tab textarea {
  display: block;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 1rem;
}
.map-content {
  display: flex;
  margin: 1.5rem 0;
  gap: 1.5rem;
}

.map-content .card-panel {
  background-color: white;
  width: 300px;
  border-radius: 12px;
  padding: 24px;
}

.map-content .card-panel .card-panel-header {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.map-content .card-panel h2 {
  font-weight: 200;
  margin-top: 1rem;
}

.map-content .card-panel ul {
  margin-top: 1rem;
}

.map-content .card-panel ul li {
  margin: 1rem 0;
}

.map-content .card-panel ul li.liCheckedT1 {
  background: #eee;
  padding: 1rem;
  border-radius: 5px;
}

.map-content .card-panel ul li.liCheckedT1 .progress {
  height: 0.8rem;
  background: linear-gradient(
    90deg,
    rgba(137, 135, 249, 1) 0%,
    rgba(23, 228, 23, 1) 35%,
    rgba(236, 245, 19, 1) 66%,
    rgba(255, 0, 0, 1) 100%
  );
  border-radius: 5px;
  margin-top: 0.5rem;
}

.map-content .card-panel ul li.liCheckedT1 .subtitle {
  margin-top: 0.5rem;
  font-size: 0.7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.map-content .card-panel ul li ul {
  margin-left: 1rem;
}
.map-content .card-panel ul li ul li label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
}

.map-content .card-panel ul li.divider {
  font-size: 0.8rem;
  font-weight: bold;
  text-transform: uppercase;
  margin: 1.5rem 0;
}

#mapgoogle {
  width: 100%;
  height: 500px;
  position: relative;
}

#map {
  flex: 1;
  position: relative;
}

#map .buttons-ctrl {
  position: absolute;
  z-index: 1000;
  right: 1rem;
  top: 1rem;
}

#map .layers-ctrl {
  position: absolute;
  z-index: 1000;
  right: 1rem;
  bottom: 1rem;
}

#mapes,
#mapes-occurrences {
  flex: 1;
  height: 670px;
}

.mapes.invisible {
  display: none;
}

.date-button {
  background-color: rgba(217, 211, 211, 0.807);
  color: rgb(7, 7, 7);
  padding: 10px 20px;
  border: none;
  margin-right: 10px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 20px;
  margin-top: 20px;
}
.date-button:hover,
.date-button.active {
  opacity: 0.9;
  background-color: #43b3ae;
  color: white;
}

.btn-uncheck {
  border: 2px solid #000;
  display: block;
  width: 100%;
  padding: 0.5rem;
  border-radius: 5px;
  margin-top: 2rem;
}
.btn-uncheck:hover {
  background-color: #f5f5f5;
}

.search-boxs {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 300px;
  height: 40px;
}
.search-boxs input[type='text'] {
  width: 100%;
  height: 100%;
  padding: 10px 20px 10px 40px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 10px;
}
.search-boxs .icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 20px;
  color: #e7e2e2;
}

.map-button {
  background-color: #f3e7e7;
  color: #000000;
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 10px;
}

.map-button:hover,
.map-button.active {
  background-color: #ffffff;
  color: #000000;
}

.icon-marker-1 {
  display: block;
  width: 5px;
  height: 5px;
  background-color: rgb(209, 53, 43);
  border-radius: 100%;
  box-shadow: 0px 0px 0px 5px rgba(209, 53, 43, 0.3);
}

.icon-marker-2 {
  display: block;
  width: 5px;
  height: 5px;
  background-color: #52aba4;
  border-radius: 100%;
  box-shadow: 0px 0px 0px 5px rgba(82, 171, 164, 0.3);
}

.icon-marker-3 {
  display: block;
  width: 5px;
  height: 5px;
  background-color: #b98859;
  border-radius: 100%;
  box-shadow: 0px 0px 0px 5px rgba(185, 136, 89, 0.3);
}

.icon-marker-4 {
  display: block;
  width: 5px;
  height: 5px;
  background-color: rgb(23, 52, 207);
  border-radius: 100%;
  box-shadow: 0px 0px 0px 5px rgba(23, 52, 207, 0.3);
}

.icon-marker-5 {
  display: block;
  width: 5px;
  height: 5px;
  background-color: rgb(231, 183, 8);
  border-radius: 100%;
  box-shadow: 0px 0px 0px 5px rgba(231, 183, 8, 0.3);
}

.icon-marker-6 {
  display: block;
  width: 5px;
  height: 5px;
  background-color: rgb(117, 117, 117);
  border-radius: 100%;
  box-shadow: 0px 0px 0px 5px rgba(117, 117, 117, 0.3);
}
.icon-marker-7 {
  display: block;
  width: 5px;
  height: 5px;
  background-color: rgb(232, 14, 203);
  border-radius: 100%;
  box-shadow: 0px 0px 0px 5px rgba(232, 14, 203, 0.3);
}
.icon-marker-8 {
  display: block;
  width: 5px;
  height: 5px;
  background-color: blueviolet;
  border-radius: 100%;
  box-shadow: 0px 0px 0px 5px rgba(138, 43, 226, 0.3);
}
.d-none {
  display: none;
}
</style>
